module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6VRMqp/tc-custom/9781449423216.jpg?1709697143816",
      "alt": "This image is the cover for the book Zombies Need Love Too"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Zombies Need Love Too\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"... Mark Tatulli's Lio isn't just a charmingly macabre strip about a creepy little boy who dabbles in the occult; it's also a daily demonstration of how a skilled artist can express sometimes complicated comedic ideas without any dialogue. . . .\"— "), _c('i', [_vm._v("A.V. Club, The Onion")]), _c('br'), _c('br'), _vm._v("Lio is a small boy with a penchant for befriending squids, monsters,  and aliens. He's a curious scientist, a comic-book fan, defender of  the defenseless, and creator of an army of zombie bunnies. All without  saying a word. "), _c('i', [_vm._v("Zombies Need Love Too")]), _vm._v(" is Lio's fifth book with AMP."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Tatulli\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0